export default {
    login_register: 'Вход/Регистрация',
    booking_confirmation_title: 'Потвърждение на резервация',
    booking_confirmation_body: 'Благодарим Ви за резервацията. Моля, вижте подробностите по-долу.',
    insurance_requirements_modal_disclaimer: `С извършването на тази резервация потвърждавам, че: нямам присъди или пътнотранспортни нарушения през последните 5 години. Не ми е отказвана застраховка, не ми е отменяна полица, не ми е отказвано подновяване или не съм бил задължен да плащам по-висока премия или да спазвам специални условия от застраховател. Не съм бил дисквалифициран от шофиране. Нямам висящи дела или разследвания. Нямам присъди за кражба, измама или нечестност през последните 5 години. Не страдам от дефектно зрение или слух (некоригирани с очила или слухов апарат), сърдечно заболяване, диабет, припадъци или каквито и да е физически или психически увреждания. Не съм имал инциденти през последните 5 години. Моля, кликнете {0}, ако не отговаряте на тези изисквания`,
    insurance_requirements_here: 'тук',
    insurance_requirements: 'Прочетох и разбрах {0}',
    ir: 'Застрахователни изисквания',
    location: 'Локация',
    pickup_location: 'Място на вземане',
    dropoff_location: 'Място на връщане',
    vehicle: 'Автомобил',
    pickup_and_dropoff: 'Вземане и връщане (местно време)',
    view_voucher: 'Виж ваучер',
    identity_verification_body: 'Ще трябва да потвърдите самоличността си преди да вземете автомобила',
    identity_verification_title: 'Потвърдете самоличност',
    search_again: 'Търсете отново',
    refrigerated: 'хладилен',
    aircon_lower: 'климатик',
    aircon: 'Климатик',
    refrigeration: 'Хладилен',
    not_available: 'Drive & Go е наличен само за хора с документи за самоличност и шофьорска книжка от следните държави.',
    check_if_included: 'Проверете дали вашата държава е включена.',
    included_in_booking: 'Включено в тази резервация',
    cdw_with_excess: 'CDW с франшиза',
    theft_protection: 'Защита от кражба с франшиза',
    risk_reduction: 'Намаляване на риска',
    free_extras: 'Имате право на два безплатни екстри <br /> с тази резервация.',
    continue: 'Продължи',
    luggage_large_short_label: 'Г',
    luggage_medium_short_label: 'С',
    luggage_small_short_label: 'М',
    luggage_large_long_label: 'голям',
    luggage_medium_long_label: 'среден',
    luggage_small_long_label: 'малък',
    fuel_unspecified_label: 'неуточнено',
    transmission_manual_label: 'Ръчна',
    transmission_automatic_label: 'Автоматична',
    make_a_booking: 'Направете резервация',
    pickup_date: 'Дата на вземане',
    dropoff_date: 'Дата на връщане',
    driver_age: 'Шофьор между 30 - 65',
    enter_driver_age: 'Моля, въведете възрастта на шофьора',
    promo_code: 'Промо код',
    search: 'Търси',
    dropoff_date_cannot_be_before_pickup_date: 'Датата на връщане не може да е преди датата на вземане',
    pickup_date_cannot_be_in_the_past: 'Датата на вземане не може да е в миналото',
    pickup_time_cannot_be_in_the_past: 'Часът на вземане не може да е в миналото',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Часът на връщане трябва да е след часа на вземане, ако е на същия ден',
    vehicle_filters: 'Филтри за автомобили',
    reset: 'Нулирай',
    transmission: 'Трансмисия',
    all: 'Всички',
    manual: 'Ръчна',
    auto: 'Автоматична',
    passengers: 'Пътници',
    vehicle_type: 'Тип автомобил',
    filter: 'Филтър',
    vehicle_search: 'Търсене на автомобил',
    edit: 'Редактирай',
    no_results: 'Няма резултати, отговарящи на критериите.',
    small_cars: 'Малки автомобили',
    medium_cars: 'Средни автомобили',
    large_cars: 'Големи автомобили',
    estate_cars: 'Комби',
    suvs: 'SUV',
    mpvs: 'MPV',
    vans: 'Ванове',
    camper_vans: 'Кемпери',
    premium: 'Премиум',
    unspecified: 'неуточнено',
    large: 'голям',
    medium: 'среден',
    small: 'малък',
    automatic: 'автоматична',
    you_have_been_refunded: 'Сумата ви е възстановена.',
    please_customer_service: 'За да направите резервация, моля, свържете се с нашия отдел за обслужване на клиенти.',
    contact_customer_service: 'Свържете се с обслужване на клиенти',
    booking_failed: 'Резервацията ви не можа да бъде обработена този път.',
    summary: 'Обобщение',
    reforestation_and_protection: 'Подкрепете залесяването и защитата на дъждовните гори в Коста Рика',
    cost_of_rental: 'Цена на наема',
    to_pay_now: 'Да се плати сега',
    greenheart_donation: 'Дарение Green Heart',
    total_cost: 'Обща цена на наема',
    tc_agreement: 'Прочетох и разбрах {0}.',
    tc: 'Общи условия',
    receive_offers: 'Бих искал да получавам специални оферти по имейл.',
    donate: 'Да, искам да даря {amount}',
    pay_now: 'Плати {amount} сега',
    driver_details: 'Данни на шофьора',
    complete_driver_details: 'Моля, попълнете данните на шофьора.',
    are_you_the_driver: 'Вие ли сте шофьорът?',
    have_an_account: 'Вече имате акаунт?',
    login: 'Вход',
    or: 'или',
    first_name: 'Име на шофьора',
    last_name: 'Фамилия на шофьора',
    email: 'Имейл адрес',
    phone_number: 'Мобилен номер',
    unable_to_save_driver_information: 'Неуспешно запазване на данните на шофьора. Моля, опитайте отново.',
    pay_online_now: 'Плати сега',
    day: 'Ден',
    choose_location: 'Изберете локация',
    location_not_found: 'Съжаляваме, не можахме да намерим желаната локация.',
    add: 'Добави',
    remove: 'Премахни',
    free_extra: 'Безплатна екстра',
    free: 'БЕЗПЛАТНО!',
    fast_track_notice: 'Ограничения за произход на документи важат за тази услуга. Налично само за хора с документи от',
    complete_booking: 'Завърши резервацията',
    choose_card: 'Моля, изберете карта или добавете нова.',
    add_billing_details: 'Моля, добавете данни за плащане.',
    card_number: 'Номер на карта',
    card_holder_name: 'Име на картодържателя',
    card_exp: 'ММ / ГГ',
    card_cvc: 'CVC',
    save_card: 'Запази карта?',
    amount_charged: 'Вашата карта ще бъде таксувана',
    payment_confirmation: 'Потвърдете резервацията и платете',
    payment_methods: 'налични методи за плащане',
    use_saved_card: 'x използвай запазена карта',
    use_different_card: '+ използвай друга карта',
    book_now: 'Резервирай сега',
    minimum_age: 'Само над {age} години',
    excess_liability: 'Франшиза',
    security_deposit: 'Депозит',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Същото за същото',
    full_to_full: 'Пълен до пълен',
    miles_per_rental: '{mileage} безплатни мили на наем',
    km_per_rental: '{mileage} безплатни км на наем',
    unlimited_mileage: 'Неограничен пробег',
    unlimited_mileage_km: 'Неограничени км',
    non_amendable: 'Не може да се променя',
    non_refundable: 'Не се възстановява',
    free_cancellation_until: 'Безплатно анулиране до',
    cancellation_in_line_with: 'Анулиране съгласно',
    tcs: 'Общи условия',
    free_extras_on_collection: 'Две безплатни екстри при вземане',
    glass_and_tyres_covered: 'Покрити стъкла и гуми',
    number_of_passengers: 'Брой пътници',
    number_of_bags: 'Брой чанти',
    fuel_type: 'Тип гориво',
    co2: 'CO2',
    book_type: 'Резервирай {type}',
    processing: 'Обработка',
    actual_price: 'Действителна цена',
    tooltip: 'Цената в {currencyCode} е ориентировъчна според обменния курс, цената в {currency} е обвързваща.',
    deposit: 'Депозит',
    pay_online: 'Плати сега',
    pay_online_without_extras: 'Цена на наема',
    extras_on_arrival: 'Екстри при пристигане',
    insurance_on_arrival: 'Намаляване на риска - плащане при пристигане',
    insurance_online: 'Намаляване на риска - плати сега',
    extras_online: 'Екстри - плати сега',
    green_heart_donation: 'Дарение Green Heart',
    why_use_drive_and_go: 'Защо да използвате Drive & Go?',
    straight_to_car: 'Директно до автомобила',
    no_queues: 'Без опашки',
    self_checkout: 'Самообслужване',
    cant_lose_key: 'Не може да загубите ключа',
    online_id_check: 'Онлайн проверка на самоличност',
    phone_as_key: 'Телефон като ключ',
    premiumplus_benefits_includes: 'Включени са и предимствата на Premium Plus+',
    book_drive_go: 'Резервирай Drive & Go',
    distance_allowance: 'Разрешено разстояние',
    duration: 'Продължителност',
    view_more_bookings: 'Виж още резервации',
    to_pay_on_arrival: 'Да се плати при пристигане',
    pay_on_arrival: 'Плати при пристигане',
    unlimited: 'Неограничено',
    return_date: 'Дата на връщане',
    postcode: 'Пощенски код',
    country: 'Държава',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go е наличен само за хора с документи за самоличност и шофьорска книжка от следните държави:',
        drive_and_go_today: 'Drive & Go резервация за днес!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Защо да използвате Drive & Go?',
        straight_to_car: 'Директно до автомобила',
        no_queues: 'Без опашки',
        self_checkout: 'Самообслужване',
        cannot_lose_the_key: 'Не може да загубите ключа',
        online_id_check: 'Онлайн проверка на самоличност',
        phone_as_a_key: 'Телефон като ключ',
        premium_plus_benefits_also_included: 'Включени са и предимствата на Premium Plus+',
        book_drive_and_go: 'Резервирай Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Палатка и оборудване',
        quick_and_easy: 'Бързо и лесно за монтиране',
        travel_freedom: 'Свобода на пътуване',
        affordable_campervan_alternative: 'Достъпна алтернатива на къмпера',
        lightweight_and_compact: 'Леко и компактно',
        fully_insured: 'Напълно застраховано',
    },
    my_bookings: 'Моята резервация',
    no_bookings: 'Няма резервация',
    my_profile: 'Моят профил',
    no_bookings_to_display: 'Няма резервации за показване.',
    search_great_car_rental_deals: 'Търсете страхотни оферти за коли под наем за следващото си пътуване.',
    odometer_at_collection: 'Километраж при вземане',
    fuel_at_collection: 'Гориво при вземане',
    start_check_in: 'Започнете чекиране',
    start_collection: 'Започнете вземане',
    recent_bookings: 'Скорошна резервация',
    damage: {
        updated_damage_report_submitted: 'Подаден е актуализиран доклад за щети. Наш служител ще се свърже с вас при необходимост.',
        add_additional_damage: 'Добавете допълнителна щета',
        you_may_report_additional_damage_up_to: 'Може да докладвате допълнителни щети до 24 часа след връщане на автомобила',
        specify_damage: 'Посочете щетата',
        please_choose_the_area_and_type_of_damage: 'Моля, изберете областта и вида на щетата',
        type_of_damage: 'Вид щета',
        is_this_more_than_5_cm: 'Това повече от 5 см ли е?',
        please_take_or_select_a_photo: 'Моля, направете или изберете снимка',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Моля, направете снимка, така че щетата да се вижда ясно',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Ако е необходимо, може да добавите още снимка, изберете иконата за добавяне',
        save_image: 'Запази снимка',
        save_images: 'Запази снимки',
        damage_saved_successfully: 'Щетата е запазена успешно',
        add_photo: 'Добави снимка',
    },
    checkout: {
        start_collection: 'Започнете вземане',
        collect_vehicle: 'Вземете автомобила',
        we_will_let_you_know_the_details: 'Ще ви уведомим за локацията и подробностите, за да намерите автомобила.',
        inspect: 'Инспектирайте',
        we_will_ask_for_four_photos_from_each_corner: 'Ще поискаме четири снимки от всеки ъгъл на автомобила, както и на нови щети, ако има такива.',
        fuel_and_milage: 'Гориво и километраж',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Потвърждавате показанията на километража и горивото в началото на наема.',
        sign: 'Подпишете',
        sign_the_rental_agreement: 'Подпишете договора за наем.',
        away_you_go: 'Тръгвайте',
        you_are_free_to_take_to_the_road: 'Свободни сте да тръгнете!',
        collect_your_vehicle: 'Вземете автомобила си',
        get_directions: 'Вземете упътвания',
        hide_directions: 'Скрий упътванията',
        local_time: 'местно време',
        tel: 'Тел',
        getting_to_the_location: 'Как да стигнете до локацията',
        get_vehicle_details: 'Вземете подробности за автомобила',
        view_map: 'Виж карта',
        unlock_vehicle_and_continue: 'Отключете автомобила и продължете',
        unable_to_connect_to_vehicle: 'Не може да се свърже с автомобила',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Не успяхме да се свържем с автомобила - моля, проверете дали сте до правилния автомобил и опитайте отново.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Не успяхме да намерим резервацията за автомобила. Моля, опитайте по-късно.',
        odometer_and_fuel: 'Километраж и гориво',
        odometer: 'Километраж',
        please_confirm_the_odometer_and_fuel_readings: 'Ако е възможно, потвърдете показанията на километража и горивото.',
        the_odometer_field_is_required: 'Полето за километраж е задължително',
        and_must_be_greater_than_the_checkout_odometer: 'и трябва да е по-голямо от километража при вземане',
        confirm: 'Потвърди',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Моля, направете снимка от всеки ъгъл на автомобила',
        pre_existing_damage: 'Съществуващи щети',
        no_pre_existing_damage: 'Няма съществуващи щети.',
        new_damage: 'Нова щета',
        add_additional_damage: 'добавете допълнителна щета',
        no_new_damage_to_report: 'Няма нови щети за докладване',
        checkout_complete: 'Чекирането е завършено',
        start_rental: 'Започнете наема',
        congratulations_name_it_is_time_to_take_to_the_road: 'Поздравления {customer_name}, време е да тръгнете!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Не можем да завършим чекирането на автомобила.',
        please_do_the_following: 'Моля, направете следното',
        remove_all_belonging_and_lock_the_vehicle: 'Премахнете всички вещи и заключете автомобила.',
        lock_vehicle: 'Заключете автомобила',
        once_you_have_contacted_customer_services: 'След като се свържете с обслужване на клиенти',
        vehicle_location: 'Локация на автомобила',
        collect_your: 'Вземете вашия',
        from: 'От',
        key_in_glove_box: 'ключът ви е в жабката',

        keyholder: {
            not_detected: 'Ключът не е открит в държача',
            not_detected_please_try_again: 'Моля, поставете ключа в държача и опитайте отново.',

            not_installed: 'Държачът не е инсталиран',
            not_installed_please_contact_customer_service: 'Държачът не е инсталиран, моля, свържете се с обслужване на клиенти.',
        },
        keyring: {
            look_up_failed: 'Неуспешно търсене на ключодържател',
            look_up_failed_please_contact_customer_service: 'Неуспешно търсене на ключодържател, моля, свържете се с обслужване на клиенти.',
        },
        key: {
            invalid: 'Ключът е невалиден',
            invalid_please_contact_customer_service: 'Вашият ключ е невалиден, моля, свържете се с обслужване на клиенти.',

            expired: 'Ключът е изтекъл',
            expired__please_contact_customer_service: 'Вашият ключ е изтекъл, моля, свържете се с обслужване на клиенти.',
        },
    },
    checkin: {
        start_check_in: 'Започнете чекиране',
        vehicle_location: 'Локация на автомобила',
        tell_us_where_you_have_parked: 'Кажете ни къде сте паркирали автомобила.',
        fuel_and_milage: 'Гориво и километраж',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Потвърждавате показанията на километража и горивото в края на наема.',
        inspect: 'Инспектирайте',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Ще поискаме четири снимки от всеки ъгъл на автомобила, както и на нови щети, възникнали по време на наема.',
        lock: 'Заключете',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Проверете дали не сте оставили вещи и заключете автомобила.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Моля, кажете ни къде сте паркирали автомобила',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'След като автомобилът е заключен, няма да можете да го отключите отново.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, проверете дали не сте оставили вещи, заключете автомобила и ако е необходимо върнете физическия ключ в държача.',
        lock_vehicle: 'Заключете автомобила',
        complete_check_in: 'Завършете чекирането',
        inspection: 'Инспекция',
        complete_vehicle_check_in: 'Завършете чекирането на автомобила',
        we_are_unable_to_complete_your_vehicle_check_in: 'Не можем да завършим чекирането на автомобила.',
        please_contact_customer_services: 'Моля, свържете се с обслужване на клиенти',
        once_you_have_contacted_customer_services: 'След като се свържете с обслужване на клиенти',
        please_amend_odometer_to_be_greater_than: 'Моля, коригирайте километража да е по-голям от {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Договор за наем',
        agreement_between: 'Договор между',
        and: 'и',
        sign_rental_agreement: 'Подпишете договора за наем',
        i_have_read_and_understood_the_terms_and_conditions: 'Прочетох и разбрах Общите условия и приемам състоянието на автомобила',
    },
    additional_options: 'Допълнителни опции',
    booking_details: 'Детайли за резервацията',
    price_for_x_days: 'Цена за {qty_of_days} ден | Цена за {qty_of_days} дни',
    cancelled: 'Отменена',
    upcoming: 'Предстояща',
    active: 'Активна',
    full_insurance_no_deposit: 'Пълна застраховка и без депозит',
    excess: '{amount} франшиза',
    deposit: '{amount} депозит',
    included_daily_distance: '{distance} {unit} на ден',
    miles: 'мили',
    kilometers: 'километри',
    collection_details_title: 'Детайли за вземане',
    collection_details_not_found: 'Няма дефинирани детайли за вземане за тази локация',
    free_cancellation: 'Безплатно анулиране',
    no_deposit: 'Без депозит',
    benefit_from: 'Възползвайте се от',
    for_only_per_day: 'Само за {price} на ден',
    upgrade_mee: 'UpgradeMee',
};
